import { useMutation } from '@tanstack/react-query';
import { adminAuthAPI } from '../api';
import { toast } from 'react-toastify';
import { useT } from '../../../i18n';

// Admin authentication hook
export const useAdminLogin = () => {
  const t = useT();
  return useMutation({
    mutationFn: adminAuthAPI.login,
    onSuccess: (data) => {
      toast.success(t('auth.toast.loginSuccess'));
      // Store admin tokens with admin prefix
      localStorage.setItem('admin_access_token', data.data.token);
      localStorage.setItem('admin_refresh_token', data.data.refresh_token);
      localStorage.setItem('adminUserData', JSON.stringify(data.data.userData));
    },
    onError: (error: any) => {
      toast.error(t('auth.toast.loginFailed'));
    },
  });
};
